<template>
<div class="chapter">
<div class="inner_page">
      ﻿

    
        <title>TOC</title>
<link href="stylesheet.css" rel="stylesheet" type="text/css"/>
<h1 style="text-align:center;"><br/> TABLE OF CONTENTS </h1>
<table cellpadding="2" cellspacing="2">
<colgroup><col style="text-align:right;"/>
<col style="text-align:left;"/>
</colgroup><tbody><tr>
<td>4</td>
<td>
<span href="#/chapter4" title="Link target outside of Sample">HELPFUL HINTS</span>
</td>
</tr>
<tr>
<td>
<div class="toc_L1"></div>
</td>
<td>
<div class="toc_L1">
<span href="#/chapter5" title="Link target outside of Sample">APPETIZERS</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter5" title="Link target outside of Sample">BBQ CHICKEN KABOBS</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter6" title="Link target outside of Sample">BLUE CHEESE CHICKEN DIP</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter7" title="Link target outside of Sample">FLAMING SOUTHWEST DIP</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter8" title="Link target outside of Sample">NACHOS CON POLLO</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter9" title="Link target outside of Sample">BUFFALO WINGS</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter10" title="Link target outside of Sample">SWEET AND SPICY CHICKEN WINGS</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter11" title="Link target outside of Sample">CHICKEN TOSTADA BITES</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter12" title="Link target outside of Sample">TANGY STRAWBERRY CHICKEN BITES</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter13" title="Link target outside of Sample">COLD VEGETABLE PIZZA</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter14" title="Link target outside of Sample">RANCH CHICKEN CHEESE BALL</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter15" title="Link target outside of Sample">ROBYN’S ARTICHOKE SPREAD</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L1"></div>
</td>
<td>
<div class="toc_L1">
<span href="#/chapter16" title="Link target outside of Sample">SOUPS &amp; SALADS</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter16" title="Link target outside of Sample">CHEESY BROCCOLI CHICKEN SOUP</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter17" title="Link target outside of Sample">CHICKEN TACO SOUP</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter18" title="Link target outside of Sample">WHITE LIGHTNING CHILI</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter19" title="Link target outside of Sample">CHICKEN NOODLE SOUP</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter20" title="Link target outside of Sample">CHICKEN AND DUMPLINGS</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter21" title="Link target outside of Sample">RANCH CHICKEN BEAN SOUP</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter22" title="Link target outside of Sample">CHICKEN CORN CHOWDER</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter23" title="Link target outside of Sample">SOUTHWEST CHICKEN SOUP</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter24" title="Link target outside of Sample">POTATO CHICKEN CHOWDER</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter25" title="Link target outside of Sample">SWEET AND SOUR ALMOND SALAD</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter26" title="Link target outside of Sample">SUMMER CHICKEN SALAD</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter27" title="Link target outside of Sample">WINTER CHICKEN SALAD</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter28" title="Link target outside of Sample">CHOPPED FIESTA SALAD</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter29" title="Link target outside of Sample">CHICKEN CAESAR SALAD</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter30" title="Link target outside of Sample">CURRIED CHICKEN SALAD</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter31" title="Link target outside of Sample">CHICKEN AND RICE SALAD</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter32" title="Link target outside of Sample">MEDITERRANEAN CHICKEN SALAD</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter33" title="Link target outside of Sample">BOWTIE PASTA SALAD</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L1"></div>
</td>
<td>
<div class="toc_L1">
<span href="#/chapter34" title="Link target outside of Sample">SANDWICHES &amp; WRAPS</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter34" title="Link target outside of Sample">NUTTY PINEAPPLE CHICKEN SANDWICHES</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter35" title="Link target outside of Sample">GRILLED SWISS SANDWICHES</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter36" title="Link target outside of Sample">ZESTY CHICKEN BURGERS</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter37" title="Link target outside of Sample">GRILLED HONEY MUSTARD CHICKEN SANDWICHES</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter38" title="Link target outside of Sample">PULLED CHICKEN SANDWICHES</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter39" title="Link target outside of Sample">BBQ BACON CHICKEN BURGER</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter40" title="Link target outside of Sample">CHICKEN PARMESAN SUBS</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter41" title="Link target outside of Sample">ITALIAN CHICKEN SUBS</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter42" title="Link target outside of Sample">CHICKEN CAESAR WRAPS</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter43" title="Link target outside of Sample">CRANBERRY CHICKEN SPINACH WRAPS</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter44" title="Link target outside of Sample">CHICKEN SALAD WRAPS</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter45" title="Link target outside of Sample">CALIFORNIA WRAPS</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L1"></div>
</td>
<td>
<div class="toc_L1">
<span href="#/chapter46" title="Link target outside of Sample">COMPANY’S COMING</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter46" title="Link target outside of Sample">APPLE CIDER CHICKEN</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter47" title="Link target outside of Sample">LEMON BASIL CHICKEN</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter48" title="Link target outside of Sample">GARLIC LOVER’S ROAST CHICKEN</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter49" title="Link target outside of Sample">FLORENTINE CHICKEN ROLLS</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter50" title="Link target outside of Sample">FESTIVE CHICKEN CRESCENT WREATH</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter51" title="Link target outside of Sample">GOURMET CHICKEN SPIRALS</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter52" title="Link target outside of Sample">CREAMY SLOW COOKER CHICKEN</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter53" title="Link target outside of Sample">APRICOT PINEAPPLE CHICKEN THIGHS</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter54" title="Link target outside of Sample">CHICKEN FAJITAS</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter55" title="Link target outside of Sample">COLA CHICKEN</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter56" title="Link target outside of Sample">HAWAIIAN HAYSTACKS</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter57" title="Link target outside of Sample">CAJUN CHICKEN AND PEPPERS</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter58" title="Link target outside of Sample">PAPRIKA CHICKEN</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L1"></div>
</td>
<td>
<div class="toc_L1">
<span href="#/chapter59" title="Link target outside of Sample">MAIN DISHES</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter59" title="Link target outside of Sample">PLUM GOOD CHICKEN</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter60" title="Link target outside of Sample">BALSAMIC CHICKEN STACKS</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter61" title="Link target outside of Sample">CHICKEN STIR-FRY</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter62" title="Link target outside of Sample">ALMOND-CRUSTED CHICKEN</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter63" title="Link target outside of Sample">LEMONADE CHICKEN</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter64" title="Link target outside of Sample">PICANTE CHICKEN</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter65" title="Link target outside of Sample">BACON-WRAPPED CHICKEN</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter66" title="Link target outside of Sample">CHICKEN CORDON BLEU</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter67" title="Link target outside of Sample">CRANBERRY CHICKEN AND RICE</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter68" title="Link target outside of Sample">ONION-BAKED CHICKEN</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter69" title="Link target outside of Sample">MUSHROOM-STUFFED CHICKEN BREASTS</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter70" title="Link target outside of Sample">PECAN-CRUSTED CHICKEN BREASTS</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter71" title="Link target outside of Sample">SWEET HAWAIIAN CHICKEN</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter72" title="Link target outside of Sample">CHICKEN AND YAM BAKE</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L1"></div>
</td>
<td>
<div class="toc_L1">
<span href="#/chapter73" title="Link target outside of Sample">INTERNATIONAL ENTREES</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter73" title="Link target outside of Sample">TANDOORI CHICKEN</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter74" title="Link target outside of Sample">CHICKEN SATAY WITH PEANUT SAUCE</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter75" title="Link target outside of Sample">PASTEL DE CHOCLO</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter76" title="Link target outside of Sample">CANJA CHICKEN SOUP</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter77" title="Link target outside of Sample">KELAGUEN</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter78" title="Link target outside of Sample">CHICKEN ENCHILADA STACKS</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter79" title="Link target outside of Sample">POMEGRANATE CHICKEN</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter80" title="Link target outside of Sample">MEDITERRANEAN CHICKEN</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter81" title="Link target outside of Sample">CHICKEN ITALIANO</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter82" title="Link target outside of Sample">30-MINUTE PAELLA</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter83" title="Link target outside of Sample">ASIAN LETTUCE WRAPS</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter84" title="Link target outside of Sample">CHICKEN YAKISOBA</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter85" title="Link target outside of Sample">JAMAICAN JERK SALAD</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter86" title="Link target outside of Sample">CHICKEN STROGANOFF</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter87" title="Link target outside of Sample">CHICKEN CURRY</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L1"></div>
</td>
<td>
<div class="toc_L1">
<span href="#/chapter88" title="Link target outside of Sample">FAMILY FAVORITES</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter88" title="Link target outside of Sample">BBQ CHICKEN PIZZA</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter89" title="Link target outside of Sample">CHICKEN ALFREDO PIZZA</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter90" title="Link target outside of Sample">BREADED CHICKEN NUGGETS</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter91" title="Link target outside of Sample">OVEN-FRIED BUTTERMILK CHICKEN</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter92" title="Link target outside of Sample">PARMESAN-CRUSTED DRUMSTICKS</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter93" title="Link target outside of Sample">FAMILY FIESTA CASSEROLE</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter94" title="Link target outside of Sample">ONE-DISH SUNDAY SUPPER</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter95" title="Link target outside of Sample">CHICKEN FAJITA QUESADILLAS</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter96" title="Link target outside of Sample">EASY CHICKEN PICATTA</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter97" title="Link target outside of Sample">CHICKEN BROCCOLI CASSEROLE</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter98" title="Link target outside of Sample">RANCH-SEASONED CHICKEN</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter99" title="Link target outside of Sample">CHICKEN POTPIE</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter100" title="Link target outside of Sample">CHICKEN AND SAUSAGE CASSOULET</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter101" title="Link target outside of Sample">MUSHROOM AND ARTICHOKE CHICKEN</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter102" title="Link target outside of Sample">SALSA CHICKEN</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter103" title="Link target outside of Sample">CHICKEN AND RICE CASSEROLE</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter104" title="Link target outside of Sample">CHICKEN PASTRY PACKETS</span>
</div>
</td>
</tr>
<tr>
<td>
<div class="toc_L2"></div>
</td>
<td>
<div class="toc_L2">
<span href="#/chapter105" title="Link target outside of Sample">GRANDMA DIRCKS’ CHICKEN CASSEROLE</span>
</div>
</td>
</tr>
<tr>
<td>106</td>
<td>
<span href="#/chapter106" title="Link target outside of Sample">NOTES</span>
</td>
</tr>
<tr>
<td>109</td>
<td>
<span href="#/chapter109" title="Link target outside of Sample">ABOUT THE AUTHORS</span>
</td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?7d1a9676